import AuthStore from '@/stores/auth';
import NotificationsStore from '@/stores/notifications';
import LoadingStore from '@/stores/loading';
import ValidationStore from '@/stores/validation';

export const auth = new AuthStore();

export const notifications = new NotificationsStore();

export const loading = new LoadingStore();

export const validation = new ValidationStore();

// export const dummy = () => true;
